import React from 'react';
import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const useStyles = makeStyles({
  alertStyle: {
    fontWeight: "bold",
    color: "#FF0000"
  }
})

function HomeIntro(props) {
  const [introText, setIntroText] = useState("");

  const classes = useStyles();

  useEffect(() => {
    console.log(`Fetching (GET) '/law/api/online-cle/GetClientSettings'`);
    axios.get(`/law/api/online-cle/GetClientSettings`)
      .then(res => {
        console.log(res.data);

        if (res.data != null) {
          setIntroText(res.data.IntroText);
        }
      });
  }, []);

  return (
    <React.Fragment>
      <Typography variant="h3" component="h1">Lectures Available for CLE Credit</Typography>
      <Box mt={2} mb={3}>

        {introText.length !== 0 ?
          <Typography variant="h5" className={classes.alertStyle} >
            {introText}
          </Typography>
          :
          <></>
        }

        {/*
          <Typography variant="h5" className={classes.alertStyle} >
          During this month, individuals who complete an online CLE course between March 1, 2024, and March 30, 2024, 11:59 pm, will have their CLE credits reported to the Supreme Court of Ohio on March 31, 2024, at 9:00 am.
          </Typography>
          <br />
        */}

        <Typography variant="subtitle1" >
          Thank you for your interest in the Case Western Reserve University School of Law’s Online CLE program. These courses have been approved by the Supreme
          Court of Ohio Commission on Continuing Legal Education for general self-study/internet instruction. To watch a video for CLE credit, you must be logged
          in and follow the appropriate instructions for completing the video and submitting a CLE credit application.
        </Typography>
      </Box>
      <Box mt={2} mb={3}>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="h5" component="h2">View Instructions</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div>
              To view a program and receive credit, you are required to log in. If you have not done so, please click the login button in the top right to create an account. Logging
              in will allow the system to save your viewing progress, so that if you need to leave the video and return later to finish, you will not have to start over at the beginning.<br />
              <br />
              Twice during the video, a different 3-letter code will appear on the screen for 30 seconds.  <strong>If you plan to apply for CLE credit, write down both of these codes.
                Then, at the end of the video, click on “apply for CLE.”  In the CLE form, please enter both activity codes to verify that you have watched the video.</strong>
              &nbsp; Please disregard any codes mentioned in the program.  Only the codes that appear on the screen for 30 seconds will be valid.  Once you complete and submit the CLE form, you will receive an email confirmation that your form has been submitted.
              <br />
              <br />
              <strong>Please do not view the videos in full screen. This may prevent you from viewing the codes. Do not click on the YouTube icon. Viewing the videos from YouTube will also prevent you from seeing the CLE credit codes.</strong><br />
              <br />
              Payment is only required for non-alumni who wish to receive CLE credit. Online CLE credit is free to CWRU Law alumni and $25 per video for non-alumni.
              To receive CLE credits you must:
              <ol>
                <li>Log-in to the Online CLE application</li>
                <li>View videos and write down the two verification codes</li>
                <li>Submit a CLE application and evaluation by clicking the "Apply for CLE" button.</li>
                <li>If you are not an alum, you will be redirected to our payment system for payment.</li>
              </ol>
              <br />
              <u>Your CLE’s will be reported to the Ohio Supreme Court during the first three business days of the next month.</u> Please keep in mind that the evaluation form is a requirement of the Ohio Supreme Court Commission
              on Continuing Legal Education for all in-person and online CLE programs.<br />
              <br />
              This is a newer site, and you need to create an account.  Your previous login information will not work.
              <br /><br />
              These courses have been approved by the Supreme Court of Ohio Commission on Continuing Legal Education for general self-study/internet instruction.
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Box>
    </React.Fragment>
  );
}

export default HomeIntro;
